import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import {HttpClient, HttpResponse} from '@angular/common/http';

export abstract class BaseHttpService {

  constructor(private http: HttpClient) {
  }

  private static API_URL = environment.apiUrl;

  protected post<T>(url: string, body: T): Observable<any> {
    return this.http.post(BaseHttpService.API_URL + url, body).pipe(
      map(res => res)
    );
  }

  protected get(url: string): Observable<HttpResponse<any>> {
    let API_URL = url;
    if (!url.includes('http')) {
      API_URL = BaseHttpService.API_URL + url;
    }
    return this.http.get(API_URL, {observe: 'response'}).pipe(
      map(res => res as HttpResponse<any>)
    );
  }

  protected delete<T>(url: string): Observable<HttpResponse<any>> {
    return this.http.delete<T>(BaseHttpService.API_URL + url, {observe: 'response'}).pipe(
      map(res => res as HttpResponse<any>)
    );
  }

  protected put<T>(url: string, body: T): Observable<HttpResponse<any>> {
    return this.http.put(BaseHttpService.API_URL + url, body, {observe: 'response'}).pipe(
      map(res => res as HttpResponse<any>)
    );
  }

  protected patch<T>(url: string, body: T): Observable<HttpResponse<any>> {
    return this.http.patch(BaseHttpService.API_URL + url, body, {observe: 'response'}).pipe(
      map(res => res as HttpResponse<any>)
    );
  }
}
